import { render, staticRenderFns } from "./MessengerCommentManagement.vue?vue&type=template&id=7f639ed2&scoped=true"
import script from "./MessengerCommentManagement.vue?vue&type=script&lang=js"
export * from "./MessengerCommentManagement.vue?vue&type=script&lang=js"
import style0 from "./MessengerCommentManagement.vue?vue&type=style&index=0&id=7f639ed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f639ed2",
  null
  
)

export default component.exports